const m=".color-swatch, .thumbnail-swatch, .block-swatch, .block-underline",p="[data-variant-picker-label]",f=".variant-picker__option-values",d=()=>window.matchMedia("(hover: hover) and (pointer: fine)").matches,s=e=>e==null?void 0:e.querySelector(p),E=e=>{var t,n,r;return((t=e.getAttribute("data-option-label"))==null?void 0:t.trim())||((r=(n=e.querySelector(".sr-only"))==null?void 0:n.textContent)==null?void 0:r.trim())||""},h=e=>{e&&(e.textContent=e.getAttribute("data-default-label")||e.textContent)};document.addEventListener("pointerover",e=>{var i,c;if(e.pointerType==="touch"||!d())return;const t=(c=(i=e.target).closest)==null?void 0:c.call(i,m);if(!t)return;const n=t.closest(".variant-picker__option"),r=s(n),o=E(t);r&&o&&(r.textContent=o)},{passive:!0});document.addEventListener("pointerout",e=>{var r,o;if(e.pointerType==="touch"||!d())return;const t=(o=(r=e.target).closest)==null?void 0:o.call(r,f);if(!t)return;const n=e.relatedTarget;n instanceof Node&&t.contains(n)||h(s(t.closest(".variant-picker__option")))},{passive:!0});function u(e){var o;const t=document.forms[e.getAttribute("form-id")];if(!((o=t==null?void 0:t.elements)!=null&&o.namedItem("id")))return;const n=e.querySelector("[data-size-option]");if(!n)return;n.querySelector("input[data-option-position]:checked")||(t.elements.namedItem("id").value="")}function a(e=document){e.querySelectorAll("variant-picker[data-require-selection]").forEach(t=>{u(t)})}document.addEventListener("DOMContentLoaded",()=>{a()});document.addEventListener("variant:change",e=>{var r;const t=(r=e.detail)==null?void 0:r.formId;if(!t)return;const n=document.querySelector(`variant-picker[form-id="${t}"][data-require-selection]`);n&&u(n)});document.addEventListener("product:rerender",()=>{requestAnimationFrame(()=>a())});document.addEventListener("dialog:after-show",e=>{const t=e.target;t instanceof HTMLElement&&t.classList.contains("quick-buy-modal")&&requestAnimationFrame(()=>a(t))},!0);document.addEventListener("click",e=>{const t=e.target.closest(".policy-checkbox a");t&&(e.preventDefault(),e.stopPropagation(),window.open(t.href,"_blank","noopener,noreferrer"))});const L="(max-width: 999px)";function v(){return window.matchMedia(L).matches}function b(e){if(!v())return;const t=e.querySelector("[data-sidebar-auto-expand]");!t||t.getAttribute("aria-expanded")==="true"||requestAnimationFrame(()=>{t.click()})}function l(e=document){const t=e.querySelector("#sidebar-menu");!t||t.dataset.autoExpandBound==="true"||(t.dataset.autoExpandBound="true",t.addEventListener("dialog:after-show",()=>{b(t)}))}document.addEventListener("DOMContentLoaded",()=>{l()});document.addEventListener("shopify:section:load",e=>{l(e.target)});

/* ==== Sticky bar: wybór wariantu (belka Dodaj do koszyka) ==== */
(function () {
  if (window.__stickyVariantInit) return;
  window.__stickyVariantInit = true;

  var STR = (window.themeVariables && window.themeVariables.strings) || {};
  var T = {
    chooseSize: STR.stickyChooseSize || 'Wybierz rozmiar',
    chooseOption: STR.stickyChooseOption || 'Wybierz opcje',
    soldOut: STR.stickySoldOut || 'Wyprzedane'
  };

  var STYLE_ID = 'sticky-variant-style';
  var css = [
    'product-sticky-bar buy-buttons.has-sticky-variant{display:flex;align-items:stretch;gap:.625rem}',
    'product-sticky-bar buy-buttons.has-sticky-variant>button,product-sticky-bar buy-buttons.has-sticky-variant>.button{flex:1 1 auto;min-width:0}',
    '.sticky-variant{display:flex;gap:.5rem;flex:0 0 auto}',
    '.sv-dd{position:relative;width:210px}',
    '.sv-dd__toggle{display:flex;align-items:center;justify-content:space-between;gap:1rem;width:100%;height:100%;min-height:44px;padding:0 1.125rem;background:#fff;color:#1c1c1c;border:1px solid rgba(28,28,28,.2);border-radius:var(--rounded-button,0);font:inherit;font-size:.75rem;letter-spacing:.2em;text-transform:uppercase;line-height:1;cursor:pointer;transition:border-color .2s}',
    '.sv-dd__toggle:hover,.sv-dd.is-open .sv-dd__toggle{border-color:#1c1c1c}',
    '.sv-dd__toggle:focus-visible{outline:2px solid #1c1c1c;outline-offset:2px}',
    '.sv-dd__label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '.sv-dd:not(.has-value) .sv-dd__label{color:rgba(28,28,28,.6)}',
    '.sv-dd__toggle::after{content:;flex:none;width:7px;height:7px;margin-top:-4px;border-right:1.4px solid currentColor;border-bottom:1.4px solid currentColor;transform:rotate(45deg);transition:transform .25s,margin .25s}',
    '.sv-dd.is-open .sv-dd__toggle::after{transform:rotate(-135deg);margin-top:3px}',
    '.sv-dd__list{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:20;margin:0;padding:.375rem 0;list-style:none;background:#fff;border:1px solid #1c1c1c;box-shadow:0 12px 30px rgba(0,0,0,.08);opacity:0;visibility:hidden;transform:translateY(-4px);transition:opacity .18s,transform .18s,visibility 0s linear .18s}',
    '.sv-dd--up .sv-dd__list{top:auto;bottom:calc(100% + 6px);transform:translateY(4px)}',
    '.sv-dd.is-open .sv-dd__list{opacity:1;visibility:visible;transform:none;transition-delay:0s}',
    '.sv-dd__option{display:flex;align-items:center;justify-content:space-between;gap:1rem;padding:.75rem 1.125rem;font-size:.75rem;letter-spacing:.2em;text-transform:uppercase;color:#1c1c1c;cursor:pointer;outline:none;transition:background .15s}',
    '.sv-dd__option:hover,.sv-dd__option:focus-visible{background:#f3f3f3}',
    '.sv-dd__option[aria-selected=true]{font-weight:600}',
    '.sv-dd__option[aria-selected=true]::after{content:;width:5px;height:10px;margin-right:2px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg) translateY(-2px)}',
    '.sv-dd__option.is-sold-out{color:rgba(28,28,28,.4)}',
    '.sv-dd__option.is-sold-out .sv-dd__text{text-decoration:line-through}',
    '.sv-dd__note{font-size:.625rem;letter-spacing:.1em;text-decoration:none}',
    '.sv-dd.is-error .sv-dd__toggle{border-color:#d0011b;animation:svShake .3s}',
    '@keyframes svShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}',
    '@media screen and (max-width:699px){.sticky-variant{flex:0 0 42%;max-width:42%}.sv-dd{width:100%}.sv-dd__toggle{padding:0 .875rem;letter-spacing:.12em}.sv-dd__option{padding:.875rem;letter-spacing:.12em}}'
  ].join('').split('content:;').join('content:' + String.fromCharCode(39, 39) + ';');

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = css;
    document.head.appendChild(s);
  }

  function optionText(label) {
    var t = label.getAttribute('data-option-label');
    if (t && t.trim()) return t.trim();
    var span = label.querySelector('span');
    return ((span ? span.textContent : label.textContent) || '').trim();
  }

  /* Opcje z głównego selektora sterowane polami radio (bez linków do innych produktów) */
  function collectOptions(picker) {
    var result = [];
    picker.querySelectorAll('fieldset.variant-picker__option').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var name = legend ? legend.textContent.trim().replace(/:$/, '').trim() : '';
      var values = [];
      fieldset.querySelectorAll('label[for]').forEach(function (label) {
        var input = document.getElementById(label.getAttribute('for'));
        if (!input || input.type !== 'radio' || input.disabled || label.hidden) return;
        values.push({ id: input.id, text: optionText(label), checked: input.checked, soldOut: label.classList.contains('is-disabled') });
      });
      var isSize = fieldset.hasAttribute('data-size-option');
      if (values.length > 1 || (values.length === 1 && isSize)) result.push({ name: name, isSize: isSize, values: values });
    });
    return result;
  }

  function signature(options) {
    return options.map(function (o) {
      return o.name + ':' + o.values.map(function (v) { return v.id + (v.checked ? '*' : '') + (v.soldOut ? '!' : ''); }).join(',');
    }).join('|');
  }

  var openDd = null;

  function closeDd(dd, focusToggle) {
    if (!dd) return;
    dd.classList.remove('is-open');
    dd.querySelector('.sv-dd__toggle').setAttribute('aria-expanded', 'false');
    if (focusToggle) dd.querySelector('.sv-dd__toggle').focus();
    if (openDd === dd) openDd = null;
  }

  function openDropdown(dd) {
    if (openDd && openDd !== dd) closeDd(openDd);
    var rect = dd.getBoundingClientRect();
    dd.classList.toggle('sv-dd--up', rect.top > window.innerHeight / 2);
    dd.classList.add('is-open');
    dd.classList.remove('is-error');
    dd.querySelector('.sv-dd__toggle').setAttribute('aria-expanded', 'true');
    openDd = dd;
    var target = dd.querySelector('.sv-dd__option[aria-selected=true]') || dd.querySelector('.sv-dd__option');
    if (target) target.focus({ preventScroll: true });
  }

  function choose(dd, li) {
    var input = document.getElementById(li.getAttribute('data-input'));
    closeDd(dd, true);
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function buildDropdown(option, index) {
    var dd = document.createElement('div');
    dd.className = 'sv-dd';
    var listId = 'sv-dd-list-' + index;
    var selected = null;
    option.values.forEach(function (v) { if (v.checked) selected = v; });
    if (selected) dd.classList.add('has-value');

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'sv-dd__toggle';
    toggle.setAttribute('aria-haspopup', 'listbox');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', listId);
    toggle.setAttribute('aria-label', option.name);
    var label = document.createElement('span');
    label.className = 'sv-dd__label';
    label.textContent = selected ? selected.text : (option.isSize ? T.chooseSize : T.chooseOption);
    toggle.appendChild(label);

    var list = document.createElement('ul');
    list.className = 'sv-dd__list unstyled-list';
    list.id = listId;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', option.name);

    option.values.forEach(function (v) {
      var li = document.createElement('li');
      li.className = 'sv-dd__option' + (v.soldOut ? ' is-sold-out' : '');
      li.setAttribute('role', 'option');
      li.setAttribute('tabindex', '-1');
      li.setAttribute('aria-selected', v.checked ? 'true' : 'false');
      li.setAttribute('data-input', v.id);
      var text = document.createElement('span');
      text.className = 'sv-dd__text';
      text.textContent = v.text;
      li.appendChild(text);
      if (v.soldOut) {
        var note = document.createElement('span');
        note.className = 'sv-dd__note';
        note.textContent = T.soldOut;
        li.appendChild(note);
      }
      list.appendChild(li);
    });

    toggle.addEventListener('click', function () {
      if (dd.classList.contains('is-open')) closeDd(dd); else openDropdown(dd);
    });
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openDropdown(dd); }
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.sv-dd__option');
      if (li) choose(dd, li);
    });
    list.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.sv-dd__option'));
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(i + 1, items.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(i - 1, 0)].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) choose(dd, items[i]); }
      else if (e.key === 'Escape' || e.key === 'Tab') { closeDd(dd, e.key === 'Escape'); }
    });

    dd.appendChild(toggle);
    dd.appendChild(list);
    return dd;
  }

  function render(bar) {
    var formId = bar.getAttribute('form');
    var buyButtons = bar.querySelector('buy-buttons');
    if (!formId || !buyButtons) return;

    var picker = document.querySelector('variant-picker[form-id=' + JSON.stringify(formId) + ']');
    var existing = buyButtons.querySelector('.sticky-variant');
    var options = picker ? collectOptions(picker) : [];

    if (!options.length) {
      if (existing) existing.remove();
      buyButtons.classList.remove('has-sticky-variant');
      return;
    }

    var sig = signature(options);
    if (existing && existing.getAttribute('data-sig') === sig) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'sticky-variant';
    wrapper.setAttribute('data-sig', sig);
    options.forEach(function (option, i) { wrapper.appendChild(buildDropdown(option, formId + '-' + i)); });

    if (existing) existing.replaceWith(wrapper);
    else buyButtons.insertBefore(wrapper, buyButtons.firstChild);
    buyButtons.classList.add('has-sticky-variant');
  }

  function renderAll() {
    document.querySelectorAll('product-sticky-bar[form]').forEach(render);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; renderAll(); }, 30);
  }

  document.addEventListener('click', function (e) {
    if (openDd && !openDd.contains(e.target)) closeDd(openDd);

    /* Bez wybranego wariantu kliknięcie przycisku na belce otwiera listę zamiast wysyłać pusty formularz */
    var btn = e.target.closest && e.target.closest('product-sticky-bar buy-buttons [type=submit]');
    if (!btn) return;
    var dd = btn.closest('buy-buttons').querySelector('.sv-dd:not(.has-value)');
    if (!dd) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openDropdown(dd);
    dd.classList.remove('is-error');
    void dd.offsetWidth;
    dd.classList.add('is-error');
  }, true);

  function init() {
    if (!document.querySelector('product-sticky-bar')) return;
    injectStyle();
    renderAll();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('variant:change', schedule);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) schedule();
    });
    document.addEventListener('product:rerender', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ==== Alert: ten sam produkt w innym rozmiarze (ograniczenie "domowej przymierzalni") ====
   Wklej na KOŃCU pliku assets/custom.js.
   Działa przy dodawaniu do koszyka (karta produktu, belka sticky, quick buy):
   jeśli w koszyku jest już ten sam produkt (ten sam kolor/pozostałe opcje) w INNYM rozmiarze,
   zamiast dodania pokazuje się okno z trzema przyciskami:
   [Przejdź do tabeli] [Zadzwoń do nas: numer] [Dodaj mimo wszystko]
   Shop the look korzysta z window.SizeDupAlert.check() / .open() (na końcu tego bloku).
*/
(function () {
  if (window.__sizeDupInit) return;
  window.__sizeDupInit = true;

  var PHONE_DISPLAY = '+48 515 818 600';
  var PHONE_HREF = 'tel:+48515818600';

  var locale = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'pl').toLowerCase();
  var T = locale.indexOf('en') === 0 ? {
    title: 'This item is already in your cart',
    text: 'You already have this item in your cart in size {sizes}. Not sure which size to choose? Check the size chart or give us a call and we will help you find the right one. We are available Monday to Friday, 8:00–16:00.',
    chart: 'Go to size chart',
    call: 'Call us: ' + PHONE_DISPLAY,
    add: 'Add anyway',
    close: 'Close'
  } : {
    title: 'Ten produkt jest już w koszyku',
    text: 'Masz już ten model w koszyku w rozmiarze {sizes}. Nie wiesz, który rozmiar wybrać? Zajrzyj do tabeli wymiarów albo zadzwoń do nas i pomożemy dobrać właściwy. Jesteśmy dla Ciebie dostępni od PN – PT w godzinach 8:00–16:00.',
    chart: 'Przejdź do tabeli',
    call: 'Zadzwoń do nas: ' + PHONE_DISPLAY,
    add: 'Dodaj mimo wszystko',
    close: 'Zamknij'
  };

  var SIZE_NAMES = ['rozmiar', 'size'];
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- style ---------- */
  var css = [
    '.size-dup{border:0;padding:0;margin:auto;width:min(480px,calc(100% - 32px));max-height:calc(100% - 32px);background:#fff;color:#1c1c1c;font:inherit;overflow:auto}',
    '.size-dup::backdrop{background:rgba(28,28,28,.45)}',
    '.size-dup__inner{position:relative;display:flex;flex-direction:column;gap:1.25rem;padding:2.25rem 1.75rem 1.75rem}',
    '.size-dup__title{margin:0;padding-right:2.5rem}',
    '.size-dup__text{margin:0;line-height:1.6}',
    '.size-dup__actions{display:flex;flex-direction:column;gap:.75rem;margin-top:.5rem}',
    '.size-dup__actions .button{width:100%;justify-content:center;text-align:center}',
    '.size-dup__close{position:absolute;top:1.25rem;right:1.25rem;display:flex;padding:.375rem;background:none;border:0;color:inherit;cursor:pointer}',
    '@media screen and (max-width:699px){.size-dup{width:100%;max-width:100%;margin:auto 0 0}.size-dup__inner{padding:2rem 1.25rem 1.5rem}}'
  ].join('');

  function injectStyle() {
    if (document.getElementById('size-dup-style')) return;
    var s = document.createElement('style');
    s.id = 'size-dup-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---------- dane ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); });
      productCache[handle].catch(function () { delete productCache[handle]; });
    }
    return productCache[handle];
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  function getSizeIndex(picker, product) {
    var input = picker && picker.querySelector('fieldset[data-size-option] input[data-option-position]');
    if (input) return parseInt(input.getAttribute('data-option-position'), 10) - 1;
    var names = (product.options || []).map(function (o) { return String(o && o.name ? o.name : o).toLowerCase(); });
    for (var i = 0; i < names.length; i++) if (SIZE_NAMES.indexOf(names[i]) > -1) return i;
    return -1;
  }

  function findVariant(product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  }

  /* Rozmiary tego samego produktu (ten sam kolor itp.), które już są w koszyku */
  function findOtherSizes(product, variantId, cart, sizeIndex) {
    var variant = findVariant(product, variantId);
    if (!variant) return [];
    var sizes = [];
    cart.items.forEach(function (item) {
      if (String(item.product_id) !== String(product.id) || String(item.variant_id) === String(variantId)) return;
      var other = findVariant(product, item.variant_id);
      if (!other) return;
      var sameRest = variant.options.every(function (val, i) { return i === sizeIndex || other.options[i] === val; });
      var otherSize = other.options[sizeIndex];
      if (sameRest && otherSize !== variant.options[sizeIndex] && sizes.indexOf(otherSize) === -1) sizes.push(otherSize);
    });
    return sizes;
  }

  /* ---------- okno ---------- */
  function openAlert(opts) {
    injectStyle();
    var dialog = document.createElement('dialog');
    dialog.className = 'size-dup color-scheme color-scheme--dialog';
    dialog.setAttribute('aria-labelledby', 'size-dup-title');

    var inner = document.createElement('div');
    inner.className = 'size-dup__inner';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'size-dup__close';
    close.setAttribute('aria-label', T.close);
    close.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5"/></svg>';

    var title = document.createElement('p');
    title.id = 'size-dup-title';
    title.className = 'size-dup__title h4';
    title.textContent = T.title;

    var text = document.createElement('p');
    text.className = 'size-dup__text';
    text.textContent = T.text.replace('{sizes}', opts.sizes.join(', '));

    var actions = document.createElement('div');
    actions.className = 'size-dup__actions';

    var chartTrigger = opts.chartTrigger || (opts.picker && opts.picker.querySelector('.variant-picker__size-chart'));
    if (chartTrigger) {
      var chartBtn = document.createElement('button');
      chartBtn.type = 'button';
      chartBtn.className = 'button';
      chartBtn.textContent = T.chart;
      chartBtn.addEventListener('click', function () {
        finish();
        requestAnimationFrame(function () { chartTrigger.click(); });
      });
      actions.appendChild(chartBtn);
    }

    var callBtn = document.createElement('a');
    callBtn.href = PHONE_HREF;
    callBtn.className = 'button button--outline';
    callBtn.textContent = T.call;
    actions.appendChild(callBtn);

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'button button--outline';
    addBtn.textContent = T.add;
    addBtn.addEventListener('click', function () { finish(); opts.onAdd(); });
    actions.appendChild(addBtn);

    inner.appendChild(close);
    inner.appendChild(title);
    inner.appendChild(text);
    inner.appendChild(actions);
    dialog.appendChild(inner);
    document.body.appendChild(dialog);

    function finish() {
      if (dialog.open) dialog.close();
      dialog.remove();
    }

    close.addEventListener('click', finish);
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); finish(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) finish(); });

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    (actions.firstChild || close).focus();
  }

  /* ---------- przechwycenie dodania do koszyka ---------- */
  var bypass = new WeakSet();

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (bypass.has(form)) { bypass.delete(form); return; }

    /* Uwaga: form.id zwraca pole <input name="id">, dlatego id formularza czytamy z atrybutu */
    var formId = form.getAttribute('id');
    if (!formId) return;

    var picker = document.querySelector('variant-picker[form-id="' + CSS.escape(formId) + '"]');
    var handle = picker && picker.getAttribute('handle');
    var idInput = form.elements.namedItem('id');
    var variantId = idInput && idInput.value;
    if (!handle || !variantId) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var submitter = e.submitter;
    function resubmit() {
      bypass.add(form);
      try {
        if (submitter && submitter.form === form) form.requestSubmit(submitter);
        else form.requestSubmit();
      } catch (err) {
        form.requestSubmit();
      }
    }

    Promise.all([getProduct(handle), getCart()]).then(function (res) {
      var product = res[0], cart = res[1];
      var sizeIndex = getSizeIndex(picker, product);
      if (sizeIndex < 0) return resubmit();
      var sizes = findOtherSizes(product, variantId, cart, sizeIndex);
      if (!sizes.length) return resubmit();
      openAlert({ sizes: sizes, picker: picker, onAdd: resubmit });
    }).catch(resubmit);
  }, true);

  /* ---------- dla innych modułów (Shop the look) ---------- */
  window.SizeDupAlert = {
    /* Zwraca listę innych rozmiarów tego produktu, które już są w koszyku (pusta = brak konfliktu) */
    check: function (handle, variantId) {
      return Promise.all([getProduct(handle), getCart()]).then(function (res) {
        var product = res[0], cart = res[1];
        var sizeIndex = getSizeIndex(null, product);
        if (sizeIndex < 0) return [];
        return findOtherSizes(product, variantId, cart, sizeIndex);
      });
    },
    /* opts: { sizes: [...], chartTrigger: element|null, onAdd: function } */
    open: openAlert
  };
})();
